import {Component, HostListener, OnInit} from '@angular/core';
import {DefaultDeviceCategoryFilters} from "../../../model/filters/default-device-category-filters";
import {DefaultDeviceCategory} from "../../../model/default-device-category";
import {TranslocoService} from "@ngneat/transloco";
import {AuthGuard} from "../../../common/auth-guard.service";
import {CommonMessagesService} from "../../../services/common-messages.service";
import {FiltersService} from "../../../services/filters.service";
import {DefaultDeviceCategoriesService} from "../../../services/default-device-categories.service";
import {SortOrder} from "../../../model/sort-order";

@Component({
  selector: 'app-default-device-categories',
  templateUrl: './default-device-categories.component.html',
  styleUrls: ['./default-device-categories.component.scss']
})
export class DefaultDeviceCategoriesComponent implements OnInit {

  public categories: DefaultDeviceCategory[];
  public totalCategories: number;
  public loadingCategories: boolean;

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: DefaultDeviceCategoryFilters;
  public filtersFilled: boolean;

  constructor(private defaultDeviceCategoriesService: DefaultDeviceCategoriesService,
              private i18n: TranslocoService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<DefaultDeviceCategoryFilters>) {
    this.currentFilters = new DefaultDeviceCategoryFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.categories = new Array(this.rows);
    Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
  }

  private loadCategories(offset: number, limit: number): void {
    this.loadingCategories = true;
    this.categories = new Array(this.rows);
    this.defaultDeviceCategoriesService.getDefaultDeviceCategories(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.categories = response.defaultDeviceCategories;
        this.totalCategories = response.totalElements;
        this.loadingCategories = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadCategories(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new DefaultDeviceCategoryFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true) {
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadCategories(this.first / this.rows, this.rows);
  }

  confirmAndDelete(category: DefaultDeviceCategory): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteCategory(category.name);
    });
  }

  deleteCategory(name: string): void {
    this.defaultDeviceCategoriesService.deleteDefaultDeviceCategory(name).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadCategories(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) {
      return;
    }
    const names = this.selected.map(item => item.name);
    this.defaultDeviceCategoriesService.deleteDefaultDeviceCategories(names).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadCategories(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
